import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import AssetBrandTypeCodeService from "services/Setup/Master/assetBrandTypeCodeService";
import { message, notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  assetBrandTypeCodeList: {},
};

export const getAssetBrandTypeCodeList = createAsyncThunk(
  "assetBrandTypeCode/getAssetBrandTypeCodeList",
  async (userInput, { rejectWithValue }) => {
    console.log("🚀 ~ userInputassetBrandTypeCode:", userInput);
    try {
      const response =
        await AssetBrandTypeCodeService.getAssetBrandTypeCodeList(userInput);
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      // notification.error({
      //   message: "Error",
      //   description: "Unexpected response!",
      //   duration: 3,
      // });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const assetBrandTypeCode = createSlice({
  name: "assetBrandTypeCode",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
  },

  extraReducers: (builder) => {
    builder
      //get assetBrandType code list
      .addCase(getAssetBrandTypeCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getAssetBrandTypeCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.assetBrandTypeCodeList = action.payload;
      })
      .addCase(getAssetBrandTypeCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const { showNotification, hideNotification, showLoading } =
  assetBrandTypeCode.actions;

export default assetBrandTypeCode.reducer;
